const aInputFileImagePrimary = {
  aInputFileImagePrimary: {
    buttonImage: 'Cambiar Imagen',
    logo: {
      label: 'Selecciona un logo para tu Academia...',
      alt: 'logo de mi Academia',
      messages: {
        dimensions: '* Tamaño sugerido de imagen: 173px de ancho por 41px de alto',
        extensions: '* Formatos permitidos de imagen: .gif .jpg .png'
      },
      validation: {
        fileExtension: 'Extensión de imagen no permitida.',
        fileSize: 'Tamaño de imagen no permitido.'
      }
    },

    imagen: {
      label: 'Selecciona una imagen para tu perfil...',
      alt: 'Imagen de perfil',
      messages: {
        dimensions: '* Tamaño sugerido de imagen: 173px de ancho por 41px de alto',
        extensions: '* Formatos permitidos de imagen: .gif .jpg .png'
      },
      validation: {
        fileExtension: 'Extensión de imagen no permitida.',
        fileSize: 'Tamaño de imagen no permitido.'
      }
    }
  }
}
export default aInputFileImagePrimary
